import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ar from "./Translation/ar/ar.json";
import en from "./Translation/en/en.json";

const resources = {
  en: {
    translation: en,
    websiteDir: "ltr",
  },
  ar: {
    translation: ar,
    websiteDir: "rtl",
  },
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: "ar", // Default to Arabic
    // lng: "ar", // Force default language to Arabic
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
